import { CommonCMS } from "@lib/constants/contentful";
import type { MicrocopyGetOptions } from "@lib/contentful/microcopy/MicrocopyContext";
import { useMicrocopy } from "@lib/contentful/microcopy/MicrocopyContext";

type Result<T> = Record<keyof T, string>;

type Config<T extends Record<string, string>> = {
    microcopiesWithTitles: T;
    options?: MicrocopyGetOptions;
    source?: string;
};

export const useGetHeaders = <T extends Record<string, string>>({
    microcopiesWithTitles,
    source = CommonCMS.page,
    options,
}: Config<T>): Result<T> => {
    const { getMultiple } = useMicrocopy();

    const microcopiesValues = Object.values(microcopiesWithTitles);

    const microcopies = getMultiple(source, microcopiesValues, options);

    return Object.entries(microcopiesWithTitles).reduce((acc, [title, microcopy]) => {
        // eslint-disable-next-line no-param-reassign
        acc[title] = microcopies[microcopy];
        return acc;
    }, {}) as Result<T>;
};
